module.exports = "<navbar></navbar> <h1>{{ $ctrl.name }}</h1> <section> About us. </section> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/components/about/about.html
// module id = 517
// module chunks = 0